<template>
  <footer class="footer">
    <section class="info">
      <div class="columns">
        <div class="column footer-column">
          <ul>
            <li>
              <router-link class="footer_link" to="/">Acasă</router-link>
            </li>
            <li>
              <router-link class="footer_link" to="/despre-noi">Despre noi</router-link>
            </li>
            <li>
              <router-link class="footer_link" to="/galerie">Galerie</router-link>
            </li>
            <li>
              <router-link class="footer_link" to="/contact">Contact</router-link>
            </li>
          </ul>
        </div>

        <div class="column footer-column">
          <ul>
            <li>
              <router-link class="footer_link" to="/servicii/kinetoterapie">Kinetoterapie</router-link>
            </li>
            <li>
              <router-link class="footer_link" to="/servicii/fizioterapie">Fizioterapie</router-link>
            </li>
            <li>
              <router-link
                class="footer_link"
                to="/servicii/kinetoterapie-pediatrica"
              >Kinetoterapie pediatrică</router-link>
            </li>
            <li>
              <router-link class="footer_link" to="/servicii/masaj">Masaj</router-link>
            </li>
            <li>
              <router-link
                class="footer_link"
                to="/servicii/recuperare-la-domiciliu"
              >Recuperare la domiciliu</router-link>
            </li>
          </ul>
        </div>

        <div class="column footer-column">
          <div>
            Tîrgu Mures
            <br />Adresă: Str. Livezeni, nr. 97 C
            <br />
            <br />Tel: 0265 311 303
            <br />Email: olikinetic@yahoo.com
            <br />
            <p>Program: Luni - Vineri: 09 - 18</p>
          </div>
        </div>
      </div>
    </section>

    <section class="social">
      <a href="https://www.facebook.com/kineticamures/" target="_blank">
        <img src="../assets/social-media/facebook.png" class="social_icon" />
      </a>
    </section>
    <section class="legal">
      <span>
        copyright Oli Kinetic © 2020 |
<!--        <a href="termeni" class="footer_link">Termeni şi condiţii</a>-->
<!--        |-->
        <router-link class="footer_link" to="/infoFonduri">Info fonduri</router-link> |
        <router-link class="footer_link" to="/policy">Politica de utilizare Cookie-uri</router-link>
      </span>
    </section>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style>
.footer {
  padding: 2rem 1rem 2rem !important;
  background-color: #d2d2d2 !important;
}
.social {
  padding-bottom: 4px;
}
.social_icon {
  height: 3rem;
  margin: 0.5rem;
}
</style>